import { render, staticRenderFns } from "./docReview.vue?vue&type=template&id=6afd9faa&scoped=true"
import script from "./docReview.vue?vue&type=script&lang=js"
export * from "./docReview.vue?vue&type=script&lang=js"
import style0 from "./docReview.vue?vue&type=style&index=0&id=6afd9faa&prod&lang=less&scoped=true"
import style1 from "./docReview.vue?vue&type=style&index=1&id=6afd9faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd9faa",
  null
  
)

export default component.exports